import { useEffect } from 'react';
import './CustomModal.css'; // We'll create this CSS file

const ConfirmationDialog = ({ isOpen, toggle, caption, message, onConfirm }) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        toggle();
      }
    };
    document.addEventListener('keydown', handleEscape, false);

    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [toggle]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={toggle}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{caption}</h3>
          <button onClick={toggle} className="modal-close">&times;</button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="model-footer-many">
          <button onClick={toggle} className="btn-ok">Cancel</button>
          <button onClick={onConfirm} className="btn-ok">OK</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;